import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/locationgcc/dxb/banner_bg.webp";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Dubai">
                <h1>Website Development Company in Dubai</h1>
              </div>
              <p className="main_para">
                TekRevol is a renowned digital transformation and website
                development company with years of experience providing leading
                custom web development services. We develop client-focused
                web-based solutions for clients around the globe. Our
                feature-rich, robust, exquisitely designed, and exceptionally
                built web solutions make us the premier website development
                company in Dubai.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
